/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function DeliveryProfilesDeliveryItemsEditViewController(this: JS5Object, _: JS5Object, $routeParams: JS5Object, $route: JS5Object,
                                         $location: JS5Object, PartnerEditService: JS5Object, uiGridConstants: JS5Object,
                                         ModalService: JS5Object, NotificationService: JS5Object,
                                         MediaAcceptProfileService: JS5Object, BreadcrumbService: JS5Object) {


    this.activeTabs = {
        Video: false,
        Audio: false,
        Image: false,
        Artwork: false,
        CC: false,
        Subtitle: false,
        Metadata: false,
        Archive: false
    };
    this.enabledTabs = {
        Video: true,
        Audio: true,
        Image: true,
        Artwork: true,
        CC: true,
        Subtitle: true,
        Metadata: true,
        Archive: true
    };

    //Tab Functionality
    this.onTabSelect = (tab: string) => {
        this.currentTab = tab;
        $location.search('tab', tab);
    };

    const setupBreadcrumbs = () => {
        const breadCrumbSize = _.size(BreadcrumbService.getBreadcrumbs());
        if (breadCrumbSize === 0 || breadCrumbSize === 1) {
            BreadcrumbService.addBreadcrumb({
                name: this.resolveData.partnerName,
                location: `/system/partners/edit/${$routeParams.id}/deliveryProfiles`
            });
            BreadcrumbService.addBreadcrumb({
                name: 'Delivery Profiles',
                location: `/system/partners/edit/${$routeParams.id}/deliveryProfiles/edit/${$routeParams.deliveryProfileId}`,
                params: {tab: 'deliveryItems'}
            });
        } else if (breadCrumbSize === 2) {
            BreadcrumbService.addBreadcrumb({
                name: 'Delivery Profiles',
                location: `/system/partners/edit/${$routeParams.id}/deliveryProfiles/edit/${$routeParams.deliveryProfileId}`,
                params: {tab: 'deliveryItems'}
            });
        }
    };

    this.$onInit = () => {
        this.currentTab = $location.search().tab;
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        setupBreadcrumbs();
    };
}


angular.module('prism-ui.deliveryProfiles').component('deliveryProfilesDeliveryItemsEditView', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/delivery-profiles-delivery-items-edit-view-template.html',
    controller: DeliveryProfilesDeliveryItemsEditViewController,
    bindings: {
        resolveData: '<'
    }
});
